import { AutogenModelCustomer, AutogenRowCustomer } from "./autogen/AutogenModelCustomer";

export class ModelCustomer extends AutogenModelCustomer<RowCustomer> {
    constructor() {
        super(RowCustomer);
    }
}

export class RowCustomer extends AutogenRowCustomer {
}